import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from '@atlassian/jira-intl';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import ThirdPartConnectorIllustration from '../assets/kb-hub-third-party-connector.svg';
import messages from './messages.tsx';

type Props = {
	sourceType: string;
};

export const ThirdPartyNoAccessScreeen = ({ sourceType }: Props) => {
	const { formatMessage } = useIntl();
	const connector = sourceType === 'SHAREPOINT' ? 'SharePoint' : 'Google Drive';
	const title = sourceType === 'SHAREPOINT' ? 'Microsoft SharePoint' : 'Google Drive';

	return (
		<UFOSegment name="knowledge-hub-thirdparty-no-access-screen">
			<ContextualAnalyticsData
				sourceType={SCREEN}
				sourceName="Knowledge-hub-thirdparty-no-access-screen"
			>
				<EmptyState
					maxImageHeight={400}
					maxImageWidth={400}
					header={formatMessage(messages.thirdPartyLinked, {
						value: title,
					})}
					imageUrl={ThirdPartConnectorIllustration}
					description={formatMessage(messages.thirdPartyConnectorDescription, {
						value: connector,
					})}
				/>
				<FireScreenAnalytics />
			</ContextualAnalyticsData>
		</UFOSegment>
	);
};
